import RdaDrawer from './RdaDrawer'
import AccountDrawer from '@/custolink-views/asset_frontend/account/AccountDrawer'
import Scan from '@/custolink-views/asset_frontend/scan/Scan'
import FirstTimeSheet from '@/custolink-views/asset_frontend/redesigns/FirstTimeSheet'
import VoiceCallAppPageComponent from '@/custolink-views/asset_frontend/asset_view/asset_components/VoiceCallAppPageComponent'
import { PublicAssetFrontendApi$AssetComponentDtoKey } from '@/custolink-transpiled_by_server/bc.asset_interaction.api_methods'
import SelectAssetDrawer from './SelectAssetDrawer'
import AssetDrawerScope from './AssetDrawerScope'
import type { HomeModel } from './useHomeModel'

/**
 * The overlays every world shares: account, scanner, select-asset, first-time
 * explainer and the voice-call sheet. They are the existing components, so the
 * behaviour a visitor knows is identical across the three suggestions.
 */
export default function HomeOverlays({ model }: { model: HomeModel }) {
  return (
    <>
      <AccountDrawer
        open={model.accountOpen}
        close={model.closeAccount}
        useThisFeatureAlert={false}
      />
      <Scan open={model.scanOpen} close={model.closeScan} />
      <SelectAssetDrawer
        accent={model.accent}
        open={model.selectAssetOpen}
        close={model.closeSelectAsset}
        onScan={model.openScan}
      />
      <FirstTimeSheet accent={model.accent} show={model.firstTimeOpen} close={model.closeFirstTime} />
      <RdaDrawer
        title={model.voiceComponent?.name ?? ''}
        isOpen={model.voiceComponent != null}
        placement="right"
        width={'100%'}
        onClose={model.closeVoice}
        onRequestClose={model.closeVoice}
      >
        {model.voiceComponent != null &&
          model.voiceComponent.key ===
            PublicAssetFrontendApi$AssetComponentDtoKey.VoiceCall && (
            <AssetDrawerScope accent={model.accent}>
              <VoiceCallAppPageComponent component={model.voiceComponent} />
            </AssetDrawerScope>
          )}
      </RdaDrawer>
    </>
  )
}
